import dynamic from "next/dynamic";

export const Hexagon = dynamic(() => import("./component"));
